module.exports = __webpack_public_path__ + "static/media/lody-oxy.1b04fd4e.pdf";